"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Fonts_1 = require("../components/styles/Fonts/Fonts");
var FONT_FAMILY = Fonts_1.FONTS_BAGUE_SANS_NAME + ", Helvetica, Arial, sans-serif";
exports.default = {
    fonts: {
        body: FONT_FAMILY,
        heading: FONT_FAMILY,
        bague: FONT_FAMILY
    },
    fontSizes: [
        12,
        14,
        18,
        20,
        26,
        32,
        38,
        42,
        68 // 8
    ],
    fontWeights: {
        body: 500,
        thin: 100,
        light: 300,
        heading: 500,
        bold: 700,
        black: 900
    },
    lineHeights: [
        "16px",
        "20px",
        "24px",
        "42px",
        "72px" // 4
    ],
    lineHeightsV4: [
        "16px",
        "20px",
        "24px",
        "28px",
        "32px",
        "36px",
        "40px",
        "44px",
        "48px",
        "52px",
        "56px" // 10
    ],
    letterSpacing: {
        body: "0.02em",
        caps: "0.06em",
        copyright: "0.02em",
        secondaryHeading: "2.5px",
        largeHeading: "0.03em",
        label: "0.05em"
    }
};
